import { useSelector } from 'react-redux';
import { Progress, Tooltip, Image } from '@chakra-ui/react';
import styles from '../../styles';
import { Card, CardBody } from 'components/v4/Card';
import CardDetails from '../../components/CardDetails';
import { useServicesDashboard } from 'context/ServicesDashboardContext';
import getServiceCardName from '../../components/helpers/serviceCardName';
import getServiceStatusLabel, {
    getCardPillOptions,
    getStatusPill,
} from '../../components/helpers/serviceStatusLabel';
import { GetCardStatus } from '../../components/helpers/cardStatusHelper';
import vendor from 'assets/images/vendor.png';
import { VENDOR_DEFINED, OPERATOR_PLATFORM } from '../../constants';
import { isEmpty } from 'lodash';

const IconPlatform = ({ service, companyData }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const serviceStatus = useServicesDashboard();
    const cardStatus = GetCardStatus(service, serviceStatus);

    // Coloured and labelled as the service card's status pill is, so the
    // badge never says something the card doesn't.
    const pillOptions = getCardPillOptions(service, companyData);
    const pillColor = getStatusPill(cardStatus, pillOptions).value;
    const serviceName = getServiceCardName(service);
    const statusText = getServiceStatusLabel(cardStatus, pillOptions);

    const tooltipLabel = statusText
        ? `${serviceName}: ${statusText}`
        : serviceName;
    const vendorCardImage = isEmpty(service.displayImage)
        ? vendor
        : // eslint-disable-next-line no-undef
          process.env.NODE_ENV === 'development'
          ? import.meta.env.VITE_APP_IMAGE_BASE +
            '/images/' +
            service.displayImage
          : window.location.origin + '/images/' + service.displayImage;

    return (
        <Tooltip label={tooltipLabel} hasArrow openDelay={150}>
            <Card
                bg={darkMode ? 'dark.tcap' : null}
                height="40px"
                width="40px"
                sx={styles.iconCard}>
                <Progress
                    value={100}
                    sx={{ ...styles.verticalBar, width: '6px' }}
                    colorScheme={pillColor}
                    hasStripe={cardStatus?.animation}
                    isAnimated={cardStatus?.animation}
                />
                <CardBody
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                    height="40px"
                    paddingLeft="14px"
                    padding="8px">
                    <Image
                        src={
                            service?.serviceType === VENDOR_DEFINED ||
                            service?.serviceType === OPERATOR_PLATFORM
                                ? vendorCardImage
                                : CardDetails(service?.serviceType)?.icon
                        }
                        sx={{ maxWidth: '20px' }}
                    />
                </CardBody>
            </Card>
        </Tooltip>
    );
};

export default IconPlatform;
